import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation } from 'react-router-dom';
import { getEpisodeByNumber, getRandomEpisodes } from 'shared/utils/getEpisode';
import { HeroSection } from './sections/HeroSection';
import { AudioPlayerSection } from './sections/AudioPlayerSection';
import { ShowNotesSection } from './sections/ShowNotesSection';
import { EpisodeSidebarSection } from './sections/EpisodeSidebarSection';
import { ExploreMore } from './sections/ExploreMore';
import { ListenEverywhere } from 'pages/Home/sections/ListenEverywhere';
import { LISTEN_LOCALLY } from 'shared/constants/common';

export default function EpisodeDetail() {
  const { t } = useTranslation('episodeDetail');
  const { id } = useParams();
  const { hash } = useLocation();

  const number = id ?? '1'
  const episode = getEpisodeByNumber(number);
  const exploreEpisodes = useMemo(
    () => episode ? getRandomEpisodes(3, number) : [],
    [number, episode]
  );

  useEffect(() => {
    if (hash) {
      const elementId = hash.slice(1);
      setTimeout(() => {
        document.getElementById(elementId)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [hash]);

  if (!episode) {
    return (
      <div className="pb-20 md:pb-40 pt-20 max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-center">
        <h1 className="font-serif text-5xl text-on-surface text-center">{t('notFound')}</h1>
      </div>
    );
  }

  return (
    <div className="pb-20 md:pb-40">
      <HeroSection episode={episode} number={number} />
      {LISTEN_LOCALLY && episode.audioUrl
        ? <AudioPlayerSection episode={episode} />
        : <ListenEverywhere padding='tight' title={t('listenNow')} as="h3" />}

      <section className="max-w-7xl mx-auto px-6 lg:px-12 mt-16 gap-12 md:mt-32 md:gap-24 grid grid-cols-1 lg:grid-cols-12">
        <ShowNotesSection showNotes={episode.showNotes} />
        <EpisodeSidebarSection resourceGroups={episode.resources} host={episode.host} />
      </section>

      <ExploreMore episodes={exploreEpisodes} />
    </div>
  );
}
